import { css } from 'styled-components'

import { color, space } from './utils'

export const loadScreenStyles = css`
  .loading-screen {
    min-height: 100vh;
    min-height: 100dvh;
    position: absolute;
    z-index: 200;
    background: ${color('background')};
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url('/assets/loader-image.jpg');
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    will-change: opacity;
    z-index: 200;
    display: flex;
    flex-direction: row;
    gap: ${space(4)};
    padding: ${space(14)} ${space(8)};
    justify-content: center;
    align-items: center;
    color: ${color('border')};

    span {
      position: absolute;
      top: 40%;
      color: ${color('text')};
    }

    svg {
      fill: currentColor;
      position: relative;
    }
  }
`
